export enum ServiceType {

    App = "App",
    Deposit = "Deposit",
}
